import { render, staticRenderFns } from "./PreviewedFormatSelectorInstantDialog.vue?vue&type=template&id=7f0bfcc6&"
import script from "./PreviewedFormatSelectorInstantDialog.vue?vue&type=script&lang=ts&"
export * from "./PreviewedFormatSelectorInstantDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports